"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "reward" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(_ctx.outerClass)
        }, [
            (0, vue_1.createElementVNode)("div", {
                class: (0, vue_1.normalizeClass)(_ctx.getClass)
            }, null, 2)
        ], 2)
    ]));
}
